import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withAccount } from '../../../components/AccountContext';
import NewSurveyFormContainer from './NewSurveyFormContainer';
import { growlErrors } from '../../../utils/NotificationUtil';
import { createSurvey } from '../../../services/apps/SurveyService';
import { historyShape, matchShape, growlShape } from '../../../components/prop-types';
import { withGrowl } from '../../../components/GrowlNotifications';

class NewSurvey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCreate: true,
      isEdit: true,
      isSaving: false,
      commentsEnabled: true,
      managers: [],
      peers: [],
      directReports: [],
      others: [],
    };
    this.handleCancel = this.handleCancel.bind(this);
    this.saveSurvey = this.saveSurvey.bind(this);
    this.handleAddRespondent = this.handleAddRespondent.bind(this);
    this.handleRemoveRespondent = this.handleRemoveRespondent.bind(this);
  }

  handleAddRespondent(respondent, type) {
    // eslint-disable-next-line react/destructuring-assignment
    const stateType = this.state[type];
    const respondents = stateType.slice();
    respondents.push({ respondent });
    this.setState({ [type]: respondents });
  }

  handleRemoveRespondent(id, type) {
    // eslint-disable-next-line react/destructuring-assignment
    const stateType = this.state[type];
    const respondents = stateType.filter(v => v.respondent.id !== id);
    this.setState({ [type]: respondents });
  }

  async saveSurvey(formValues) {
    const survey = this.state;
    const {
      growl, currentAccount, history,
      match,
    } = this.props;
    const { respondentId } = match.params;
    const {
      surveyTemplate, name, tags, commentsEnabled,
    } = formValues;
    const input = {
      surveyTemplateId: surveyTemplate.id,
      name,
      tags,
      commentsEnabled,
      managerIds: survey.managers.map(item => item.respondent.id),
      peerIds: survey.peers.map(item => item.respondent.id),
      directReportIds: survey.directReports.map(item => item.respondent.id),
      otherIds: survey.others.map(item => item.respondent.id),
      selfRespondentId: respondentId,
    };
    try {
      const result = await createSurvey({
        ...input,
        accountId: currentAccount,
      });
      const { id } = result.createSurvey.survey;
      this.setState({ isSaving: false });
      const detailUrl = `/accounts/${currentAccount}/surveys/${id}`;
      history.push(detailUrl);
    } catch (errors) {
      growlErrors(growl, errors);
    }
  }

  handleCancel() {
    const {
      currentAccount, history,
      match,
    } = this.props;
    const { respondentId } = match.params;
    const resId = respondentId;
    const resDetailURL = `/accounts/${currentAccount}/respondents/${resId}`;
    history.push(resDetailURL);
  }

  render() {
    const {
      currentAccount,
      data: { account },
    } = this.props;

    const { respondent } = account;
    const {
      managers, peers, directReports, others,
    } = this.state;
    const respondentGroups = {
      managers, peers, directReports, others,
    };

    return (
      <NewSurveyFormContainer
        currentAccount={currentAccount}
        onCancel={this.handleCancel}
        saveSurvey={this.saveSurvey}
        respondentGroups={respondentGroups}
        handleAddRespondent={this.handleAddRespondent}
        handleRemoveRespondent={this.handleRemoveRespondent}
        respondent={respondent}
      />
    );
  }
}

const NewSurveyGraphql = withAccount(NewSurvey);

NewSurvey.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  history: historyShape.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  match: matchShape.isRequired,
  growl: growlShape.isRequired,
};

export default withGrowl(
  withRouter(
    NewSurveyGraphql,
  ),
);
